/**
 * Module dependencies.
 */

import { axiosInstance, getApiEndpoint } from 'src/core/utils/requests';
import { cleanValue } from 'src/core/utils/strings';
import { User } from 'src/types/user';

/**
 * Export `RecoverPasswordData` type.
 */

export type RecoverPasswordData = {
  nif: User['nif'];
};

/**
 * Export `recoverPassword` request.
 */

export async function recoverPassword(data: RecoverPasswordData) {
  const response = await axiosInstance.post<Record<'data', { token: string }>>(getApiEndpoint('recoverPassword'), {
    nif: cleanValue(data.nif)
  });

  return response?.data;
}
